<template>
	<div>
		<div @click="openurl(list[activedAd].link)" class="box transition-normal hover-up fadeIn animated"
			style="border: none;box-shadow: 1px 1px 10px #ccc;" v-if="show&&list.length&&!isMobile"
			:style="{width: isMobile?'20rem':'24rem','min-height':isMobile?'7.5rem':'15rem',bottom: isMobile?'10rem':'1rem'}">
			<img @click.stop="close" src="@/assets/imgs/close-icon.svg" alt="" class="poa"
				style="font-size: 1.5rem;right: -13px;top: -13px;cursor: pointer;z-index: 11;width: 2rem;height:2rem;" />
			<el-carousel height="150px">
				<el-carousel-item v-for="item in list[activedAd].main_pics" :key="item">
					<el-image class="transition-normal fadeIn animated"
						style="width: 100%;height: 10rem;cursor: pointer;" :src="item" fit="cover"></el-image>
				</el-carousel-item>
			</el-carousel>
			<div class="news-left-box-r-title hover-light" style="cursor: pointer;" v-text="list[activedAd].title">
			</div>
			<div class="df jcsb aic">
				<el-button round size="small"
					style="background-color: #23F8D2;font-weight: bold;height: 2rem;margin-top: 0.5rem;">Read
					More</el-button>
				<div style="display: flex;z-index: 10;justify-content: center;margin: 1rem 0;">
					<div style="width: 0.7rem;height: 0.7rem;border-radius: 50%;margin: 0 0.3rem;cursor: pointer;"
						v-for="(item,i) in list" :key="i" :style="{backgroundColor: i==activedAd?'#31ffda':'#a4a4a4'}"
						@click.stop="activedAd=i"></div>
				</div>
			</div>
		</div>
		<div class="cover" v-if="show&&list.length&&isMobile">
			<div @click="openurl(list[activedAd].link)" class="box transition-normal hover-up fadeIn animated"
				style="border: none;top: 50%;left: 50%;transform: translate(-50%,-50%);border-radius: 10px;width: 20rem;min-height:10rem"
				v-if="show&&list.length&&isMobile">
				<img @click.stop="close" src="@/assets/imgs/close-icon.svg" alt="" class="poa"
					style="font-size: 1.5rem;left: 50%;bottom: -3rem;cursor: pointer;z-index: 11;width: 2rem;height:2rem;transform: translateX(-50%);" />
				<el-carousel height="25vh">
					<el-carousel-item v-for="item in list[activedAd].main_pics" :key="item">
						<el-image class="transition-normal fadeIn animated"
							style="width: 100%;height: 25vh;cursor: pointer;" :src="item" fit="cover"></el-image>
					</el-carousel-item>
				</el-carousel>
				<div class="news-left-box-r-title hover-light" style="cursor: pointer;" v-text="list[activedAd].title">
				</div>
				<div class="df jcsb aic">
					<el-button round size="small"
						style="background-color: #23F8D2;font-weight: bold;height: 2rem;margin-top: 0.5rem;">Read
						More</el-button>
					<div style="display: flex;z-index: 10;justify-content: center;margin: 1rem 0;">
						<div style="width: 0.7rem;height: 0.7rem;border-radius: 50%;margin: 0 0.3rem;cursor: pointer;"
							v-for="(item,i) in list" :key="i"
							:style="{backgroundColor: i==activedAd?'#31ffda':'#a4a4a4'}" @click.stop="activedAd=i">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'advertisement',
		data() {
			return {
				show: false,
				title: 'GCI Dubai Convention and Exhibition Center launch announcement',
				activedAd: 0,
				list: [],
				isMobile: false,
			}
		},
		props: {},
		mounted() {
			this.getData()
			this.isMobile = localStorage.getItem('isMobile') == 'null' ? false : true
		},
		methods: {
			getData() {
				this.request({
					method: 'get',
					url: '/gci/activities'
				}).then(res => {
					this.list = res.data.items;
					console.log(sessionStorage.getItem("showAdvertisement"));
					let show = sessionStorage.getItem("showAdvertisement")
					if (show != 'false') this.show = true;
				}).catch(error => {
					console.error(error.response)
				})

			},
			openurl(url) {
				window.open(url)
			},
			open() {
				this.show = true;
			},
			close() {
				sessionStorage.setItem("showAdvertisement", "false");
				this.show = false;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.cover {
		width: 100%;
		height: 100%;
		position: fixed;
		background: rgba(0, 0, 0, 0.5);
		top: 0;
		left: 0;
		z-index: 100;
		cursor: pointer;
		transition: all 0.15s;
	}

	.box {
		z-index: 999;
		position: fixed;
		left: 1rem;
		display: flex;
		flex-direction: column;
		border: 1px solid #D1D1D1;
		// background: linear-gradient(180deg, rgba(124, 247, 219, 0.29) 0%, rgba(255, 255, 255, 1) 46%, #FFFFFF 100%);
		background-color: #fff;
		padding: 1rem;

		.news-left-box-r-title {
			font-size: 1.2rem;
			font-weight: bold;
			color: #333;
			margin-top: 0.5rem;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			overflow: hidden;
		}

		.news-left-box-r-dec {
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			overflow: hidden;
		}
	}
</style>